import { pick } from "lodash-es";

import type { Reducers } from "../../graph/types.ts";
import type {
  CredentialAggregates,
  CredentialMetaAggregates,
} from "../../types/assessment/data/credential.ts";
import type { AssessmentNodes } from "../../types/assessment/data/index.ts";
import { grantAggregate, keyAggregate, privilegeAggregate } from "./shared.ts";

export const credentialReducers: Reducers<
  AssessmentNodes,
  CredentialAggregates
> = {
  privileges: privilegeAggregate,
  grants: grantAggregate,
  identity: keyAggregate("identity"),
  risks: keyAggregate("risk"),
  consumers: keyAggregate("consumer"),
};

export const credentialMetaReducers: Reducers<
  AssessmentNodes,
  CredentialMetaAggregates
> = pick(credentialReducers, "consumers", "identity");
